import { Image, ImageProps, Link, LinkProps } from '@chakra-ui/react';
import AppStoreImage from 'assets_2/icons/circle/download-apple.svg';
import { useAnalytics } from 'hooks/useAnalytics';
import { GA_CLICK_EVENT_NAMES } from 'lib/firebase/ga_events';
import React from 'react';

interface AppStoreDownloadButtonProps extends LinkProps {
  imgProps?: ImageProps;
}

const AppStoreDownloadButton = ({
  imgProps = {},
  ...linkProps
}: AppStoreDownloadButtonProps) => {
  const { trackGAClickEvent } = useAnalytics();

  return (
    <Link
      href="https://insig.ht/app"
      download
      target="_blank"
      aria-label="download from apple store"
      width={['152px', '152px', '176px']}
      height="auto"
      padding="0px"
      overflow="hidden"
      {...linkProps}
      onClick={() => {
        trackGAClickEvent({
          click_event_name: GA_CLICK_EVENT_NAMES.DOWNLOAD_APP_IOS_CLICKED
        });
      }}
    >
      <Image
        alt=""
        src={AppStoreImage}
        ignoreFallback
        width="100%"
        height="auto"
        objectFit="cover"
        borderRadius={['7px', '7px', '8px']}
        {...imgProps}
      />
    </Link>
  );
};

export default AppStoreDownloadButton;
